module.exports = __webpack_public_path__ + "static/img/1.9b5b3ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/1.png
// module id = 8ucc
// module chunks = 1